import type { ViewerState } from "./types";
import { userAuthInitialState } from "./authSlice";
import { connectionInitialState } from "./connectionSlice";
import { guiInitialState } from "./guiSlice";
import { sceneInitialState } from "./sceneSlice";
import { selectionInitialState } from "./selectionSlice";
import { modulesInitialState } from "./modulesSlice";
import { selectedModuleInitialState } from "./selectedModuleSlice";
import { connectionPreviewInitialState } from "./connectionPreviewSlice";
import { instancesInitialState } from "./instancesSlice";
import { ikInitialState } from "./ikSlice";
import { jointsInitialState } from "./jointsSlice";
import { editLinksInitialState } from "./editLinksSlice";
import { endCoordsInitialState } from "./endCoordsSlice";
import { highlightingInitialState } from "./highlightingSlice";
import { selfCollisionInitialState } from "./selfCollisionSlice";
import { endCoordsGizmoInitialState } from "./endCoordsGizmoSlice";
import { jointGroupsInitialState } from "./jointGroupsSlice";
import { jointSettingsInitialState } from "./jointSettingsSlice";
import { mimicSettingsInitialState } from "./mimicSettingsSlice";
import { jointAxisVisualizationInitialState } from "./jointAxisVisualizationSlice";
import { chainJointsInitialState } from "./chainJointsSlice";
import { dragInitialState } from "./dragSlice";

export const initialViewerState: ViewerState = {
  ...userAuthInitialState,
  ...connectionInitialState,
  ...guiInitialState,
  ...sceneInitialState,
  ...selectionInitialState,
  ...modulesInitialState,
  ...selectedModuleInitialState,
  ...connectionPreviewInitialState,
  ...instancesInitialState,
  ...ikInitialState,
  ...jointsInitialState,
  ...editLinksInitialState,
  ...endCoordsInitialState,
  ...highlightingInitialState,
  ...selfCollisionInitialState,
  ...endCoordsGizmoInitialState,
  ...jointGroupsInitialState,
  ...jointSettingsInitialState,
  ...mimicSettingsInitialState,
  ...jointAxisVisualizationInitialState,
  ...chainJointsInitialState,
  ...dragInitialState,
};
